import $ from 'jquery';

class VideoBlocker {
    constructor({ cookieControl }) {
        this.cookieControl = cookieControl;
    }

    blockIfNotAllowed() {
        const videoServices = [];
        videoServices.push("youtu", "dailymotion", "vimeo");
        $.each(videoServices, (key, videoService) => {
            const videos = $('.cc-m-video-'+videoService+'-container');
            if (this.cookieControl.isVideoAllowed(videoService)) {
                $.each(videos, (key, video) => {
                    $(video).attr('src', $(video).data('src'));
                    $(video).css('display', 'block');
                });
            } else {
                $('.cc-'+videoService+'-embed-placeholder').css('display', 'block');
            }
        });
    }
}

export default VideoBlocker;



/** WEBPACK FOOTER **
 ** ./webserver/document_root/s/js/web/modules/cookieSettings/featureBlockers/VideoBlocker.esnext.js
 **/